import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone, OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { SensorRecordService } from 'src/app/services/sensorRecord.service';
import type * as am5 from '@amcharts/amcharts5';
import type * as am5xy from '@amcharts/amcharts5/xy';
import { ResizedEvent } from 'angular-resize-event-package';
import { ChartService } from 'src/app/services/chart.service';
import { NodeRecordChartModel } from 'src/app/models/sensorRecordChart.model';
import { AuthService } from 'src/app/services';
import { SensorRecord } from 'src/app/models/sensorRecord.model';
import type { VgApiService } from '@videogular/ngx-videogular/core';
import { Subscription } from 'rxjs';
import { Comment } from 'src/app/models/comment.model';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LoaderService } from 'src/app/services/loader.service';
import { Sensor } from 'src/app/models/sensor.model';
import { IMapComponent } from '../chartBase/mapComponent.interface';
import { OnZoom } from '../chartBase/onZoom.interface';
import { NodeSensorRecordsRequestModel } from 'src/app/models/nodeRecords.model';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';
import { CommonService } from 'src/app/services/common.service';
import { ParameterLookup } from '../../models/parameter.model';
import { ParameterConstants } from '../../shared/constants/parameter.constants';
import { DateFilterTypeEnum } from 'src/app/enums/dateFilterType.enum';
import { VideoResource } from 'src/app/models/videoResource.model';

@Component({
  standalone: false,
  selector: 'app-endpoints',
  templateUrl: './endpoints.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./endpoints.component.scss']
})
export class EndpointsComponent implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy, OnZoom, IMapComponent {
  selectedDateRange: any;
  selectedOrg: OrganizationLevel;
  selectedParameter: ParameterLookup;
  parameterName: string;
  searchedText: any;
  searchedEndpointName: any;
  isMobile: boolean;
  addEndpoints: boolean;
  sensors: any[] | Sensor[];
  endPoints: any;
  workforceInfoOpen: boolean;
  enableAddEndpoint: string;
  chartSlider: am5.DataItem<am5xy.IDateAxisDataItem>;
  @ViewChild('modal') modal: ElementRef;
  @ViewChild('modalClick') modalClick: ElementRef;
  @ViewChild('modalDetails') modalDetails: ElementRef;
  @ViewChild('modalDetailsClick') modalDetailsClick: ElementRef;
  readonly CHART_DIV_ID = 'end-point-chart';
  readonly CHART_VIDEO_DIV_ID = 'end-point-video-chart';
  activateEndpoint: string;
  zIndex = 0;
  endpointInfoOpen = false;
  quickHelpOpen = false;
  endpointAllDetails = false;
  chart: any;
  chartDetails: any;
  heatChart: any;
  fromDate: Date;
  toDate: Date;
  selectedParams: number[];
  itemsPerPage = 10;
  p = 1;
  selectedTab = 1;
  allParams: any = [];
  isSensor = false;
  isVideoChartHidden = false;
  videoChart: am5xy.XYChart;
  videoChartSlider: am5.DataItem<am5xy.IDateAxisDataItem>;
  videoResources: VideoResource[];
  vgApi: VgApiService;
  videoDisposers: am5.IDisposer[] = [];
  videoResource: VideoResource;
  shouldCreateSliderButtonEvents = false;
  subscriptions: Subscription[] = [];
  skipRangeTimeUpdate = false;
  skipTrackingAction = false;
  resumeVideoPlay = false;
  allSensorRecords: any = [];
  comments: Comment[] = [];

  isDateFilter = false;
  public filterStartDate = null;
  public filterEndDate = null;
  timeZone: string;

  endPointData: string;
  isFormLoading = false;
  isLoading = false;
  complianceChartType = 1;
  showSidebarView = false;

  isVideoShow = false;
  screenWidth: any;
  screenHeight: any;

  minHeight: any;

  alarmActivity: any;

  disposer: am5.IDisposer;
  initDisposer: am5.IDisposer;
  analyticsDisposer: am5.IDisposer;
  analyticsVerticalDisposer: am5.IDisposer;

  constructor(
    public dialogService: DialogService,
    private sensorRecordService: SensorRecordService,
    private chartService: ChartService,
    private authService: AuthService,
    private zone: NgZone,
    private renderer: Renderer2,
    private deviceService: DeviceDetectorService,
    private loaderService: LoaderService,
    private cd: ChangeDetectorRef,
    private commonService: CommonService
  ) {
    this.loadHeaderData();
    const currentUser = this.authService.getCurrentUser();
    this.renderer.listen('window', 'click', (e: Event) => {
      const modalId = document.getElementById('post_comment');
      if (!modalId && (!this.modalClick || !this.modal.nativeElement.contains(e.target)) &&
        (!this.modalClick || !this.modalClick.nativeElement
          || !this.modalClick.nativeElement.contains(e.target)) && !this.isDateFilter) {
      }
    });
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.modalDetails && this.modalDetailsClick && !this.isDateFilter) {
        if (!this.modalDetails.nativeElement.contains(e.target) && !this.modalDetailsClick.nativeElement.contains(e.target)) {
          this.endpointAllDetails = false;
        }
      }
    });
    this.minHeight = (window.innerHeight - 100) + 'px';
    this.timeZone = currentUser.userTimeZone;

    this.isMobile = this.deviceService.isMobile();
    if (this.isMobile && window.outerWidth < 1000) {
      // document.body.classList.add('w-50');
    }
  }

  onAnalyticsHorizontalZoom() {
    // No-op — required by OnZoom interface
  }

  onAnalyticsVerticalZoom() {
    // No-op — required by OnZoom interface
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.activateEndpoint = '';
    this.getAllParams();
    if (window.innerWidth < 700) {
      this.screenWidth = (window.innerWidth - (window.innerWidth * 0.4)) + 'px !important';
      this.screenHeight = window.innerHeight + 'px !important';
    } else {
      this.showSidebarView = true;
    }
  }

  getAllParams() {
    if (this.selectedParams) {
      this.selectedParams.map((_) => {
        const paramName = this.chartService.getParameterName(_);
        const paramField = this.chartService.getParameterField(_);
        this.allParams.push({ name: paramName, field: paramField });
      });
    }
    this.allParams.push({ name: 'Custom Value', field: 'custom' });
  }

  flyOut(flyOutTab: string, zIndex?: number) {
    this.activateEndpoint = flyOutTab;
    if (zIndex) {
      this.zIndex = zIndex;
    } else {
      this.zIndex = 0;
    }
    try {
      switch (this.activateEndpoint) {
        case 'ActiveCompliance':
          if (window.outerWidth < 1000) {
            document.documentElement.scrollTop = 0;
          }
          break;
        case 'ActiveEndPoint':
          if (window.outerWidth < 1000) {
            document.documentElement.scrollTop = 0;
          }
          break;
        case 'ActiveAlarmNotification':
          if (window.outerWidth < 1000) {
            document.documentElement.scrollTop = 900;
          }
          break;
      }
    } catch (e) {
    }
  }


  plotEndPointsInCompliance(chartType: number) {
    this.complianceChartType = chartType;
    const chartData = [];
    setTimeout(() => {
      this.zone.runOutsideAngular(() => {
        setTimeout(async () => {
          await this.chartService.createComplianceChart(chartType, chartData);
        }, 50);
      });

    }, 100);

  }

  private plotAlarmActivityInCompliance() {
    const chartData = [];
    setTimeout(() => {
      this.zone.runOutsideAngular(() => {
        setTimeout(async () => {
          await this.chartService.createAlarmActivityChart(chartData);
        }, 50);
      });
    }, 100);
  }

  endPointInfo(endPointData: any) {
    setTimeout(() => {
      this.endpointInfoOpen = true;
      this.zone.runOutsideAngular(() => {
        setTimeout(async () => {
          this.chart = await this.chartService.createChart(this.CHART_DIV_ID);
        }, 50);
      });
      this.endPointData = endPointData;
      this.createLineChart(endPointData);
    }, 100);
  }

  endpointAllDetail() {
    this.endpointAllDetails = true;
    const chartFilters = {
      startDate: this.filterStartDate,
      endDate: this.filterEndDate
    };
    setTimeout(async () => {
      this.zone.runOutsideAngular(async () => {
        this.chartDetails = await this.chartService.createChart('end-point-chart-details');
        this.chartSlider = await this.chartService.createChartRange(this.chartDetails);
        await this.chartService.drawSensorRecordChart(this.chartDetails, this.chart.data, [this.selectedParameter.parameterType], this, this.comments, chartFilters, null, null, 'node-list', false, this.parameterName);
        this.videoChart = await this.chartService.createChart(this.CHART_VIDEO_DIV_ID);
        this.videoChartSlider = await this.chartService.createChartSlider(this.videoChart, this);
        this.isVideoChartHidden = !this.videoResources || this.videoResources.length === 0 ? true : false;
        await this.chartService.drawVideoChart(this.videoChart, this.videoResources);

        this.createChartZoomEvent();

        this.chartService.disposeEvent(this.initDisposer);
        this.initDisposer = this.zone.runOutsideAngular(() => {
          return this.chartService.createChartInitialZoomEvent(this.chartDetails, this, false);
        });

        if (this.videoResources && this.videoResources.length > 0) {
          this.videoResource = this.videoResources[0];
          if (this.vgApi) {
            // tslint:disable-next-line:max-line-length
            this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider, this.videoResource.timestampStart, this.videoChart, this.videoDisposers, this);
            this.vgApi.currentTime = 0;
          } else {
            this.shouldCreateSliderButtonEvents = true;
          }
        } else {
          this.videoResource = null;
        }
      });
    }, 400);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });

    this.zone.runOutsideAngular(() => {
      this.chartService.disposeEvent(this.disposer);
      this.chartService.disposeEvent(this.initDisposer);
      this.chartService.disposeEvent(this.analyticsDisposer);
      this.chartService.disposeEvent(this.analyticsVerticalDisposer);
      if (this.chart) {
        this.chartService.disposeChartData(this.chart);
        this.chart.dispose();
      }
      if (this.videoChart) {
        this.chartService.disposeChartData(this.videoChart);
        this.videoChart.dispose();
        this.videoChartSlider = null;
        this.chartSlider = null;
      }
    });

  }

  createChartZoomEvent() {
    this.chartService.disposeEvent(this.disposer);
    this.disposer = this.zone.runOutsideAngular(() => {
      return this.chartService.createChartZoomEvent(this.chartDetails, this);
    });
    this.chartService.disposeEvent(this.analyticsDisposer);
    this.analyticsDisposer = this.zone.runOutsideAngular(() => {
      return this.chartService.createChartAnalyticsEvent(this.chartDetails, this);
    });
    this.chartService.disposeEvent(this.analyticsVerticalDisposer);
    this.analyticsVerticalDisposer = this.zone.runOutsideAngular(() => {
      return this.chartService.createChartAnalyticsVerticalZoomEvent(this.chartDetails, this);
    });
  }

  onInitialZoom(sensorRecords: SensorRecord[]) {
    if (this.initDisposer && !this.initDisposer.isDisposed() && sensorRecords && sensorRecords.length > 0) {
      this.onDataZoom(sensorRecords);
    }
  }

  onZoom(sensorRecords: SensorRecord[]) {
    if (sensorRecords && sensorRecords.length > 0 && this.initDisposer && !this.initDisposer.isDisposed()) {
      this.initDisposer.dispose();
    }
    this.onDataZoom(sensorRecords);
  }

  onDataZoom(sensorRecords: SensorRecord[]) {
    this.updateMap(sensorRecords);

    const dateAxis = this.chartDetails.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
    const minZoomed = dateAxis.getPrivate('selectionMin') as number | undefined;
    const maxZoomed = dateAxis.getPrivate('selectionMax') as number | undefined;
    if (this.videoResources && this.videoChart && this.videoResources.length > 0 && minZoomed && maxZoomed) {
      const videoDateAxis = this.videoChart.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
      videoDateAxis.set('min', minZoomed);
      videoDateAxis.set('max', maxZoomed);
    }
  }


  createLineChart(endPointData) {
    let payload = new NodeSensorRecordsRequestModel();
    payload.endPointId = endPointData["id"];
    payload.orgLevelId = this.selectedOrg?.id;
    payload.analyteId = this.selectedParameter?.id;
    payload.startDate = this.selectedDateRange?.start || 0;
    payload.endDate = this.selectedDateRange?.end || 0;
    payload.dateFilterType =
      this.selectedDateRange?.id || this.selectedDateRange?.id == 0
        ? this.selectedDateRange?.id
        : DateFilterTypeEnum.AllDates;
    payload.includeVideo = false;
    this.loaderService.show();
    this.sensorRecordService.getNodeRecords(payload).subscribe((result: NodeRecordChartModel) => {
      const sensorRecords = result.nodeRecords;
      this.comments = /* result.comments ? result.comments : */[];
      const videoResources = result.videoResources ? result.videoResources.reverse() : [];
      const noiseDate = new Date();
      noiseDate.setMinutes(noiseDate.getDate() - 500);
      this.parameterName = null;
      sensorRecords.forEach(
        record => {
          record.endPointId = endPointData['id'];
          record.timestamp *= 1000;
          if (record?.value != null) {
            this.parameterName = this.selectedParameter.name;
            record[ParameterConstants.parameterFieldName] = record.value;
          }

        });
      videoResources.forEach(
        resource => {
          resource.timestampStart *= 1000;
          resource.timestampEnd *= 1000;
        });
      this.videoResources = videoResources;
      this.allSensorRecords = sensorRecords;
      if (this.comments && Array.isArray(this.comments)) {
        this.comments.sort((x, y) => -(x.fromDate - y.fromDate));
      }

      this.zone.runOutsideAngular(async () => {
        await this.chartService.drawSensorRecordChart(this.chart, sensorRecords, [this.selectedParameter.parameterType], this, [], null, null, null, 'node-list', false, this.parameterName, ParameterConstants.parameterFieldName);
        this.loaderService.hide();
      });

    });
  }

  onResized(event: ResizedEvent, chart, chartDivId: string) {
    this.chartService.onResized(chart, event, chartDivId);
  }

  onVideoResized(event: ResizedEvent) {
    this.chartService.onResized(this.videoChart, event, this.CHART_VIDEO_DIV_ID);
  }

  updateMap(sensorRecords: SensorRecord[], shouldRecordBulletClick: boolean = false) {

  }

  onPlayerReady(api: VgApiService) {
    this.vgApi = api;

    if (this.shouldCreateSliderButtonEvents) {
      this.zone.runOutsideAngular(() => {
        // tslint:disable-next-line:max-line-length
        this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider, this.videoResource.timestampStart, this.videoChart, this.videoDisposers, this);
      });
    }

    this.subscriptions.push(api.subscriptions.timeUpdate.subscribe(event => {
      if (!this.videoResource || !this.videoResource.timestampStart) {
        return;
      }
      let currentTime = this.videoResource.timestampStart + event.srcElement.currentTime * 1000;
      currentTime = Math.max(this.videoResource.timestampStart, currentTime);
      currentTime = Math.min(this.videoResource.timestampEnd, currentTime);

      if (!this.skipRangeTimeUpdate) {
        this.videoChartSlider.set('value', currentTime);
        this.chartSlider.set('value', currentTime);
      }

      const videoDateAxis = this.videoChart.xAxes.getIndex(0) as am5xy.DateAxis<am5xy.AxisRendererX>;
      const videoAxisMin = videoDateAxis.get('min');
      const videoAxisMax = videoDateAxis.get('max');
      if (videoAxisMin && videoAxisMin > currentTime) {
        videoDateAxis.set('min', currentTime - 5000);
      }
      if (videoAxisMax && videoAxisMax < currentTime) {
        videoDateAxis.set('max', currentTime + 5000);
      }
    }));

    this.subscriptions.push(api.getDefaultMedia().subscriptions.ended.subscribe(
      this.nextVideo.bind(this)
    ));

    this.subscriptions.push(api.getDefaultMedia().subscriptions.play.subscribe(
      () => this.onVgApiAction(true)
    ));

    this.subscriptions.push(api.getDefaultMedia().subscriptions.pause.subscribe(
      () => this.onVgApiAction(false)
    ));
  }

  onVgApiAction(shouldResume: boolean) {
    if (this.skipTrackingAction) {
      return;
    }

    this.resumeVideoPlay = shouldResume;
  }

  nextVideo() {
    const index = this.videoResources.indexOf(this.videoResource);
    if (index >= 0 && index < this.videoResources.length - 1) {
      this.videoResource = this.videoResources[index + 1];
      this.isVideoShow = true;
      this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider,
        this.videoResource.timestampStart, this.videoChart, this.videoDisposers, this);
      setTimeout(() => this.playVideo(), 200);
    }
  }

  playVideo() {
    this.skipTrackingAction = true;
    this.vgApi.play();
    this.resumeVideoPlay = true;
    setTimeout(() => this.skipTrackingAction = false, 50);
  }

  jumpToVideoTime(timestamp: number) {
    if (timestamp === 0) {
      this.skipTrackingAction = true;
      this.vgApi.pause();
      this.resumeVideoPlay = false;
      setTimeout(() => this.skipTrackingAction = false, 50);
      return;
    }
    this.skipTrackingAction = false;

    let resourceUpdated = false;
    if (!this.videoResource.url || timestamp < this.videoResource.timestampStart || timestamp > this.videoResource.timestampEnd) {
      const resource = this.videoResources.find(r => r.timestampStart <= timestamp && r.timestampEnd >= timestamp);

      if (!resource) {
        this.videoResource = new VideoResource();
        this.isVideoShow = false;
        this.chartSlider.set('value', timestamp);
        return;
      }

      this.skipRangeTimeUpdate = true;
      this.videoResource = resource;
      this.isVideoShow = true;
      this.videoDisposers = this.chartService.createChartSliderButtonEvents(this.videoChartSlider, this.videoResource.timestampStart
        , this.videoChart, this.videoDisposers, this, false);
      this.videoChartSlider.set('value', timestamp);
      this.chartSlider.set('value', timestamp);
      resourceUpdated = true;
    }

    if (resourceUpdated) {
      setTimeout(() => this.setVideoTime(timestamp), 200);
    } else {
      this.setVideoTime(timestamp);
    }
  }

  setVideoTime(timestamp: number) {
    const totalTime = this.videoResource.timestampEnd - this.videoResource.timestampStart;
    let timeElapsed = timestamp - this.videoResource.timestampStart;
    timeElapsed = Math.max(0, timeElapsed);
    timeElapsed = Math.min(totalTime, timeElapsed);
    this.vgApi.currentTime = Math.min(this.vgApi.time.total, timeElapsed / 1000);
    this.skipRangeTimeUpdate = false;

    if (this.resumeVideoPlay) {
      this.playVideo();
    }
  }

  applyFilter($event) {
    this.fromDate = $event.startDate;
    this.toDate = $event.endDate;
    if (this.endPointData) {
      this.createLineChart(this.endPointData);
    }
  }

  hideView() {
    this.endpointInfoOpen = false;
    this.endpointAllDetails = false;
  }

  applyDateFilter() {
    this.isDateFilter = !this.isDateFilter;
    this.endpointAllDetail();
  }

  loadHeaderData() {
    this.subscriptions.push(
      this.commonService.selectParameterEmitter.subscribe(
        (parameter) => (this.selectedParameter = parameter)
      )
    );
    this.subscriptions.push(
      this.commonService.selectedOrgEmitter.subscribe(
        (selectedOrg) => (this.selectedOrg = selectedOrg)
      )
    );
    this.subscriptions.push(
      this.commonService.selectedDateFilterEmitter.subscribe(
        (dateFilter) => (this.selectedDateRange = dateFilter)
      )
    );
  }
}
